unable to read source [project]/node_modules/.pnpm/posthog-js@1.279.3/node_modules/posthog-js/react/src/hooks/usePostHog.ts